
import Dashboardicon from "../../assets/Dashboard.png";
import Serviceprovidersicon from "../../assets/Service_Providers.png";
import Homeownersicon from "../../assets/Homeowners.png";
import ServiceRequesticon from "../../assets/Service_Request.png";
import Settingicon from "../../assets/Settings.png";

 export const sideMenuItem=[
    {
        path:"/",
        name:"Dashboard",
        icon:Dashboardicon 
    },
    {
        path:"/service",
        name:"Service Providers",
        icon:Serviceprovidersicon 
    },
    {
        path:"/homeowner",
        name:"Home owners",
        icon:Homeownersicon 
    },
    {
        path:"/serviceRequests",
        name:"Service Requests",
        icon:ServiceRequesticon 
    },
    // {
    //     path:"/product",
    //     name:"Settings",
    //     icon:Settingicon
    // }
   
]